import { useQuery } from '@tanstack/react-query';
import { showTenantSeatUsageContract, type SeatUsageResponse } from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { seatUsageKeys } from '@/api/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Seat caps and headcounts of one tenant, read through the superadmin endpoint.
 */
export function useTenantSeatUsage(tenantId: string) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: seatUsageKeys.tenant(tenantId),
    queryFn: async ({ signal }): Promise<SeatUsageResponse['data']> => {
      const path = showTenantSeatUsageContract.path.replace(':tenantId', tenantId);
      const { data } = await apiClient.get<SeatUsageResponse>(path, { signal });
      return data.data;
    },
    enabled: !!token && !!tenantId
  });
}
